module.exports = __webpack_public_path__ + "img/s1_ci.58eb5431.svg";